import {ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient} from "@angular/common/http";
import {AddBearerTokenInterceptor} from "./core/interceptors/add-bearer-token.interceptor";
import {BrowserAnimationsModule, provideAnimations} from "@angular/platform-browser/animations";
import {provideToastr} from "ngx-toastr";
import {AlertToast} from "./shared/notifications/alert.toast";
import {NgxSpinnerModule} from "ngx-spinner";
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    provideToastr({ toastComponent: AlertToast, progressBar: true }),
    importProvidersFrom([NgMultiSelectDropDownModule.forRoot(), BrowserAnimationsModule, HttpClientModule, NgxSpinnerModule]),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddBearerTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LOCALE_ID, useValue: 'es' },
  ]
};
